import { memo } from "react";
import { VerificationAppDocumentType } from "../../../app/models";
import { TDocument } from "../../models";
import { StepComponentProps, StepRegistryEntry } from "./types";
import { DocumentTypeRenderer } from "../BinaryContent/DocumentTypeRenderer";
import { titleCase } from "../../../../utils";
import { createPlaceholderDocument } from "../../utils/pendingDocument";

const EMPTY_DOC: TDocument = createPlaceholderDocument(
  VerificationAppDocumentType.UserInformation,
);

const UserInformationStep = memo((props: StepComponentProps) => {
  const {
    stepConfig,
    documents,
    requestId,
    companyRole,
    canEdit,
    comments,
    addComment,
    userInfo,
    isMobile,
    statusesConfig,
    onRefreshDocuments,
    expandedDocumentType,
  } = props;
  const title = stepConfig.name ?? titleCase(stepConfig.type);
  const renderedDocuments = documents.length === 0 ? [EMPTY_DOC] : documents;

  return (
    <>
      {renderedDocuments.map((doc, index) => (
        <DocumentTypeRenderer
          key={`${stepConfig.type}:${index}`}
          document={doc}
          requestId={requestId}
          title={title}
          configFields={stepConfig.fields}
          companyRole={companyRole}
          canEdit={canEdit}
          comments={comments}
          addComment={addComment}
          userInfo={userInfo}
          isMobile={isMobile}
          statusesConfig={statusesConfig}
          onRefreshDocuments={onRefreshDocuments}
          defaultExpanded={
            expandedDocumentType === doc.document.documentType
          }
        />
      ))}
    </>
  );
});

export const UserInformationEntry: StepRegistryEntry = {
  StepComponent: UserInformationStep,
};
